export default "__VITE_ASSET__CI7Db8k9__"